export default __webpack_public_path__ + "static/media/woman-icon.a26789f2.png";